var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Bar'),_vm._v(" "),(!_vm.$screen.lg)?_c('Overlay'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }